export default function (selector, keyFunctions, preFunction) {
    $(selector).on('keydown', function (e) {
        const key = e.which;
        const supportedKeyCodes = [37, 38, 39, 40, 27];
        if (supportedKeyCodes.indexOf(key) >= 0) {
            e.preventDefault();
        }
        const returnedScope = preFunction.call(this);
        if (keyFunctions[key]) {
            keyFunctions[key].call(this, returnedScope);
        }
    });
}
